import { Title } from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';
import { Link } from '@tanstack/react-router';
import type { ReactNode } from 'react';

import classes from './page-header.module.css';

type BackLinkProps = {
  to: '/play' | '/play/campaigns' | '/play/campaigns/$categoryId' | '/play/daily' | '/play/endless';
  label: string;
  categoryId?: string;
  compact?: boolean;
};

export const BackLink = ({ to, label, categoryId, compact = false }: BackLinkProps) => (
  <Link
    to={to}
    params={categoryId ? { categoryId } : undefined}
    className={classes.back}
    data-compact={compact || undefined}
    aria-label={label}
    title={label}
  >
    <IconArrowLeft size={24} stroke={2.5} aria-hidden="true" />
  </Link>
);

export const BackButton = ({
  label,
  onClick,
  compact = false,
}: {
  label: string;
  onClick: () => void;
  compact?: boolean;
}) => (
  <button
    type="button"
    className={classes.back}
    data-compact={compact || undefined}
    aria-label={label}
    title={label}
    onClick={onClick}
  >
    <IconArrowLeft size={24} stroke={2.5} aria-hidden="true" />
  </button>
);

type PageHeaderProps = {
  title: string;
  eyebrow?: string;
  rightSection?: ReactNode;
};

export const PageHeader = ({ title, eyebrow, rightSection }: PageHeaderProps) => (
  <header className={classes.header} data-centered={rightSection !== undefined || undefined}>
    <div className={classes.heading}>
      {eyebrow && <span className={classes.eyebrow}>{eyebrow}</span>}
      <Title order={1} className={classes.title}>
        {title}
      </Title>
    </div>
    {rightSection !== undefined && <div className={classes.rightSection}>{rightSection}</div>}
  </header>
);
